import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IndexadoresRoutingModule } from './indexadores-routing.module';
import { IndexadoresPesquisaComponent } from './pesquisa/indexadores-pesquisa.component';
import { IndexadoresListagemComponent } from './listagem/indexadores-listagem.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';


@NgModule({
  declarations: [
    IndexadoresPesquisaComponent,
    IndexadoresListagemComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    CommonModule,
    IndexadoresRoutingModule
  ]
})
export class IndexadoresModule { }
